import InputField from "components/fields/InputField";
import TagsField from "components/fields/TagsField";
import {columnsDataCheck} from "../../../../tables/variables/columnsData";
import tableDataCheck from "../../../../tables/variables/tableDataCheck.json";
import CheckTable from "../../../../tables/components/CheckTable";
import React, {useEffect, useState} from "react";
import {MdClose} from "react-icons/md";
import axios from "axios";
import {useUserAuth} from "../../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";

const Pricing = (props) => {
    const {label, id, placeholderTags, placeholder, ...rest} = props;
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const secretKey = "cromptonssecretkey";
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"

    let initialTags = [
        /*{
            name: "chakra-ui",
            id: 1,
        },
        {
            name: "react",
            id: 2,
        },
        {
            name: "javascript",
            id: 3,
        },*/
    ];
    if (placeholderTags) initialTags = placeholderTags;
    const [tags, setTags] = useState(initialTags);
    let [dps, setDps] = useState([])
    let [selectedDp, setSelectedDp] = useState([]);


    //console.log(sessionStorage.getItem("newProduct-productName"))


    const handleSelectChange = (event) => {

        const setTagsV2 = (tags, event) => {
            const newTag = {
                name: event.target.value.trim(), // Trim leading/trailing spaces
                id: tags.length === 0 ? 1 : tags[tags.length - 1].id + 1,
            };

            const newSelectedDp = {
                id: tags.length === 0 ? 1 : tags[tags.length - 1].id + 1,
            };

            // Check if a tag with the same name already exists
            const hasDuplicate = tags.some(tag => tag.name === newTag.name);

            if (!hasDuplicate) {
                setTags([...tags, newTag]); // Add only if not a duplicate
                setSelectedDp([...selectedDp, newSelectedDp]);
                //selectedDp = [...selectedDp, newSelectedDp]

                const newSelectedItems = [...selectedDp];
                const index = newSelectedItems.indexOf(newSelectedDp.id);
                if (index > -1) {
                    newSelectedItems.splice(index, 1); // Remove if already selected
                } else {
                    newSelectedItems.push(newSelectedDp.id); // Add if not selected
                }
                setSelectedDp(newSelectedItems);
                selectedDp = newSelectedItems

                sessionStorage.setItem("newDpAddition", JSON.stringify(selectedDp.join(",")))

                //console.log(JSON.parse(sessionStorage.getItem("newDpAddition")))
            } else {
                // Handle duplicate case (optional)
                console.warn(`Duplicate tag: ${newTag.name}`); // Example warning
            }
        };

        setTagsV2(tags, event);

        //console.log(selectedDp);
        event.target.value = "Select Data Point";
    };

    const keyPress = (e) => {
        if (e.keyCode === 13) {
            setTags([
                ...tags,
                {
                    name: e.target.value,
                    id: tags.length === 0 ? 1 : tags[tags.length - 1].id + 1,
                },
            ]);
            e.target.value = "";
        }
    };

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    async function getAllDps() {
        var url = CROMPTON_ANALYTICS_URL + "v1/device/dpIds"

        //console.log("URL: ", url)
        await axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            //console.log(res.data)
            setDps(res.data)
            dps = res.data
            //setDps(res.data)

        }).catch((error) => {

            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })
    }

    useEffect(() => {
        getAllDps()
    }, []);

    return (
        <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">

            {/* Header */}
            <h1 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                Function Definition <span className="font-normal">(Optional)</span>
            </h1>
            {/* inputs */}
            {/* left side */}
            {/*<CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} />*/}
            <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="flex h-fit flex-col gap-3 md:col-span-2 md:grid md:grid-cols-3">
                    <div className="w-full md:col-span-1">
                        <div>
                            <label
                                htmlFor="currency"
                                className="ml-3 mb-2 text-sm font-bold text-navy-700 dark:text-white"
                            >
                                Data Points
                            </label>
                            <div
                                className="w-full mt-2 rounded-xl border border-gray-200 py-3 px-2.5 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                <select id="currency" className="w-full dark:!bg-navy-800"
                                        onChange={handleSelectChange}>
                                    {
                                        dps.map((item) => (
                                            <option value={item.name} key={item.dpid}>{item.name}</option>
                                            )
                                        )
                                    }


                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-span-2 ">
                    {/*<TagsField/>*/}
                    <div>
                        <label htmlFor={id} className={"mb-2 text-sm font-bold"}>
                            {label}
                        </label>
                        <div
                            className="min-h-[50px] h-stretch flex flex-row flex-wrap rounded-xl border border-gray-200 bg-none p-3 focus:border-[#004c86] dark:!border-white/10"
                            {...rest}
                        >
                            {tags.map((tag, index) => {
                                return (
                                    <div
                                        className="align-center mb-1.5 mr-1.5 flex items-center rounded-xl bg-[#004c86] py-2 px-4 text-sm font-medium"
                                        key={index}
                                    >
                                        <p className="mr-1 w-full text-white">{tag.name}</p>
                                        <MdClose
                                            className="justify-end text-white"
                                            onClick={() =>
                                                setTags([...tags.filter((element) => element.id !== tag.id)])
                                            }
                                        />
                                    </div>
                                );
                            })}
                            {/*<input
                                type="text"
                                onKeyDown={(e) => keyPress(e)}
                                id="username"
                                placeholder={placeholder}
                                className="flex h-[48px] w-full border-none bg-none p-0 text-sm outline-none dark:!bg-navy-800"
                            />*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pricing;
